export default {
  10001: 'الرجاء إدخال اسم المستخدم أو البريد الإلكتروني',
  10002: 'تم إدخال البريد الإلكتروني بشكل غير صحيح',
  10003: 'خطأ في إدخال اسم المستخدم',
  10004: 'تم إدخال كلمة المرور بشكل غير صحيح',
  10005: 'حالة مستخدم غير طبيعية',
  10006: 'اسم المستخدم موجود بالفعل',
  10007: 'البريد الالكتروني موجود بالفعل',
  10008: 'حالة المستخدم خاطئة',
  10009: 'لم يتم العثور على مستخدم مطابق',
  10010: 'منتج Expert Advisor غير صحيح',
  10011:
    'إذا كان رصيد المستخدم غير كافٍ، فيرجى إعادة شحن الوديعة أو تحريرها قبل إجراء عملية الشراء.',
  10012: 'لم يتم العثور على أيام مقابلة',
  10013: 'مبلغ الاستثمار خاطئ',
  10014: 'منتج التسوية الكمية غير صحيح',
  10015: 'غير متوفر حاليا للتداول',
  10016: 'مبلغ الشراء غير صحيح',
  10017: 'لم يتم العثور على الفترة المقابلة',
  10018: 'فشل في الحصول على معلمات النظام',
  10019: 'حالة المصادقة الحالية لهذا المستخدم غير صحيحة',
  10020: 'حالة المجموعة غير صحيحة',
  10021: 'عنوان الاستلام لم يتم ملؤه',
  10022: 'لم تتم مصادقة المستخدم بالاسم الحقيقي',
  10023: 'تم تحديد فترة القرض بشكل غير صحيح',
  10024: 'لقد اشتريت نفس المنتج بالفعل، يرجى عدم شرائه مرة أخرى',
  10025: 'الرجاء تحديد طريقة السحب',
  10027: 'لا يمكن أن يكون مبلغ القرض فارغًا',
  10028: 'لا يمكن أن تكون مدة القرض فارغة',
  10029: 'يجب أن يكون مبلغ القرض أكبر من 0',
  10030: 'تكوين مدة القرض غير موجود',
  10031: 'مبلغ القرض أقل من الحد الأدنى',
  10032: 'مبلغ القرض يتجاوز الحد الأقصى',
  10033: 'يجب ألا يكون معرف سجل القرض فارغًا',
  10034: 'سجل القرض غير موجود',
  10035: 'ليس لديك إذن للتعامل مع سجل القرض هذا',
  10036: 'حالة القرض لا تسمح بالسداد',
  10037: 'رصيد الحساب غير كافٍ',
  10108:
    'الأسهم الأمريكية خارج ساعات التداول (الإثنين–الجمعة 9:30–16:00 بتوقيت شرق الولايات المتحدة). يرجى المحاولة لاحقًا',
  10109:
    'الفوركس/المعادن الثمينة خارج ساعات التداول (الأحد 17:00–الجمعة 17:00 بتوقيت شرق الولايات المتحدة). يرجى المحاولة لاحقًا',
  10110: 'كمية التداول غير صالحة. يرجى إدخال قيمة أكبر من 0',
  20001: 'تم التقديم للمراجعة بنجاح',
  20002: 'تمت إضافة إعادة الشحن بنجاح وتم تقديمها للمراجعة',
  20003: 'تمت إضافة السحب بنجاح وتم تقديمه للمراجعة',
  20004: 'تم الشراء بنجاح',
  20005: 'تم التعديل بنجاح',
  20024: 'لقد اشتريت نفس المنتج بالفعل، يرجى عدم شرائه مرة أخرى',
  20102:
    'تم تجميد حسابك. التداول والسحوبات غير متاحة مؤقتًا. يرجى الاتصال بالدعم إذا كان لديك أسئلة.',
  20103: 'انتهت صلاحية جلسة تسجيل الدخول. يرجى تسجيل الدخول مرة أخرى.',
  20104: 'لم تقم بتسجيل الدخول. يرجى تسجيل الدخول.',
  Invite: {
    CopyLink: 'نسخ الوصلة',
    FillInAccount: 'املأ النموذج عبر الإنترنت وافتح حساب تداول',
    Fund: 'أموال',
    FundYourPrefer: 'قم بتمويل حسابك عبر أي طريقة تمويل تفضلها',
    InviteFriends: 'ادعو أصدقاء',
    InviteYourFriends: 'اعزم أصحابك',
    Register: 'يسجل',
    StartTradingPlatform: 'ابدأ التداول من خلال منصة التداول الحائزة على جوائز',
    Trade: 'تجارة',
    WhenYourRewards:
      'قم بدعوة أقاربك وأصدقائك للانضمام إلينا، وجني المكافآت السخية معًا، والبدء في طريق الثروة!',
  },
  Market: {
    CreateAPlanToTrade: 'إنشاء خطة التداول',
    ETF: 'ETF',
    ExpectedReturn: 'الربح المتوقع',
    LastPrice: 'أحدث السعر',
    Lots: 'يُسلِّم',
    OpenPrice: 'سعر الافتتاح',
    OrderAgain: 'أجل مرة أخرى',
    OrderNumber: 'رقم الأمر',
    Price: 'سعر',
    Prices: 'سعر',
    Sizes: 'يُسلِّم...',
    SpotPrice: 'سعر',
    StopLossPrices: 'سعر وقف الخسارة...',
    TakeProfitPrices: 'سعر جني الأرباح...',
    WantMoreStableEarning: 'تريد دخلًا أكثر استقرارًا',
    WhatIsSmartTrading: 'ما هو التداول الذكي',
    available: 'متاح',
    buy: 'شراء طويلة',
    buyLong: 'شراء/شراء طويل',
    buyLongBtn: 'شراء طويلة',
    chart: 'جدول',
    checkoutSuccess: 'التسوية ناجحة',
    close: 'سعر نهائي',
    confirm: 'يتأكد',
    contracts: 'عقد',
    create: 'يخلق',
    cypto: 'عملة مشفرة',
    day: 'سماء',
    down: 'يسقط',
    estimation: 'الربح المتوقع',
    forex: 'الفوركس',
    free: 'رسوم التحويل',
    frees: 'رسوم التحويل',
    futures: 'السلع',
    high: 'اغلى سعر',
    hour: 'ساعة',
    investment: 'مبلغ الاستثمار',
    leverage: 'رافعة',
    limit: 'حد السعر',
    low: 'أقل سعر',
    market: 'سعر السوق',
    min: 'دقيقة',
    mon: 'قمر',
    name: 'اسم',
    notOpen: 'الوظيفة ليست مفتوحة بعد',
    open: 'سعر الافتتاح',
    options: 'التسوية الكمية',
    optionsTime: 'وقت التسوية',
    orderConfirm: 'تأكيد الطلب',
    requiredMargin: 'الهامش المطلوب',
    return: 'دخل',
    sell: 'البيع على المكشوف',
    sellShort: 'يبيع قصير',
    sellShortBtn: 'البيع على المكشوف',
    stocks: 'مخزون',
    stopLoss: 'إيقاف الخسارة',
    stopLossPrice: 'سعر وقف الخسارة',
    takeProfit: 'اخذ ربح',
    takeProfitPrice: 'سعر جني الأرباح',
    time: 'وقت',
    up: 'يعلو',
    volume: 'مقدار',
    watchlist: 'يجمع',
    week: 'أسبوع',
  },
  SmartTrading: {
    InterInvestmentAmount: 'مبلغ الاستثمار...',
    SelectATimeframe: 'اختر فترة زمنية',
    create: 'يخلق',
    createAPlan: 'إنشاء خطة',
    dailyYield: 'الدخل اليومي',
    days: 'سماء',
    investment: 'كمية',
    investmentRange: 'حد التمويل',
    product: 'منتج',
    smrtTrading: 'مستشار الخبراء',
    timeframe: 'فترة زمنية',
  },
  aboutUs: {
    about: 'معلومات عنا',
    subtitle1: 'ملف الشركة',
    subtitle2: 'شريك',
    title: 'حول {العنوان}',
  },
  account: {
    BTCAmount: 'كمية',
    LOTS: 'يُسلِّم',
    LastDigits: 'آخر 6 أرقام',
    Lots: 'يُسلِّم',
    PaymentAmount: 'مبلغ الدفع',
    PleaseUploadSubmission: 'يرجى تحميل لقطة شاشة للدفع بالعملة المشفرة وإرسالها للتحقق.',
    Preview: 'معاينة',
    SelectImage: 'اختر صورة',
    Supports: 'التنسيقات المدعومة: JPG، JPEG2000، PNG',
    TransactionHash: 'تجزئة الصفقة',
    UploadProof: 'تحميل إثبات',
    UploadYourScreenshot: 'قم بتحميل لقطة شاشة لعملية النقل الخاصة بك',
    accountVerification: 'تأكيد الحساب',
    address: 'عنوان',
    allOrders: 'جميع الطلبات',
    amount: 'كمية',
    approved: 'تاريخ الموافقة',
    balance: 'توازن',
    buy: 'شراء طويلة',
    cancel: 'إلغاء',
    changeLanguage: 'تغيير اللغة',
    changePassword: 'تغيير كلمة المرور',
    close: 'موقف قريب',
    closePrice: 'سعر نهائي',
    closeTime: 'وقت الإغلاق',
    closed: 'مغلق',
    contactUs: 'اتصل بنا',
    copyAddress: 'انسخ العنوان',
    copySuccess: 'تم النسخ بنجاح',
    cycle: 'دورة',
    dailyRor: 'معدل العائد اليومي',
    demo: 'حساب تجريبي',
    deposit: 'إيداع',
    depositWithdraw: 'الودائع والسحوبات',
    down: 'يسقط',
    downloadPDF: 'تحميل اتفاقية القرض',
    earlyExist: 'إنهاء المعاملة',
    earlyExit: 'إنهاء المعاملة',
    earlyExitTip:
      'إذا تم إنهاء المعاملة مبكرًا، فسيقوم النظام تلقائيًا بخصم {num} من أصل المبلغ كتعويضات مقطوعة، وسيتم خصم إجمالي دخلك',
    expandMore: 'قم بتوسيع المزيد',
    expirationTime: 'تاريخ انتهاء الصلاحية',
    failed: 'يفشل',
    freeMargin: 'الهامش المحتل',
    futures: 'عقد',
    helpCenter: 'مشكلة شائعة',
    inviteFriends: 'ادعو أصدقاء',
    lastPrice: 'أحدث السعر',
    lever: 'رافعة',
    liquidatedDamages: 'الأضرار الناجمة',
    loan: 'يُقرض',
    logOut: 'تسجيل الخروج',
    logoutConfirm: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
    margin: 'الربح المتوقع',
    myAccount: 'حسابي',
    notification: 'يخطر',
    notifications: 'يخطر',
    okay: 'نعم',
    open: 'سعر الافتتاح',
    openPrice: 'سعر الافتتاح',
    openTime: 'وقت مفتوح',
    options: 'التسوية الكمية',
    optionsOrder: 'أمر التسوية الكمية',
    order: 'طلب',
    pips: 'نقاط',
    profit: 'ربح',
    putAway: 'يغلق',
    receiveAddress: 'عنوان الاستلام',
    recreatePlan: 'استمر في إنشاء خطة',
    refund: 'استرداد',
    refundTip: 'سيتم إرجاع الأموال إلى حسابك النقدي، يرجى التحقق.',
    repayNow: 'ادفع على الفور',
    repayment: 'السداد',
    repaymentAmount: 'مبلغ السداد',
    repaymentDate: 'تاريخ السداد',
    repeatOrder: 'الاستمرار في فتح الموقف',
    reviewed: 'في انتظار المراجعة',
    runTime: 'ساعات العمل',
    save: 'يحفظ',
    sell: 'البيع على المكشوف',
    settings: 'يثبت',
    smart: 'التداول الذكي',
    startTime: 'وقت البدء',
    staticincome: 'دخل ثابت',
    status: 'ولاية',
    success: 'نجاح',
    time: 'وقت',
    todayEarnings: 'أرباح اليوم',
    todayProfit: 'ربح اليوم',
    totalInterest: 'مجموع الفوائد',
    totalProfit: 'اجمالي الربح',
    totalRepayment: 'إجمالي السداد',
    totalRevenue: 'إجمالي الإيرادات',
    transFees: 'رسوم التحويل',
    transRecord: 'سجل المعاملات',
    transaction: 'تجارة',
    type: 'يكتب',
    up: 'يعلو',
    withdraw: 'سحب المال',
    withdrawNow: 'سحب الأموال الآن',
  },
  bangZhuZhongXin: 'مركز المساعدة',
  biaoDian: 'علامات ترقيم',
  board: {
    content: 'يلبي هذا البرنامج جميع احتياجاتك بأفضل الخبرات التقنية',
    continue: 'يكمل',
    skip: 'القفز فوق',
    title: 'أفضل منصة تداول',
  },
  bread: {
    introduction: 'مقدمة',
  },
  chaKan: 'يفحص',
  chongZhi: 'فوق حتى',
  chongZhiJinexiaoYuZuiDiChongZhiJinE: 'مبلغ إعادة الشحن أقل من الحد الأدنى لمبلغ إعادة الشحن',
  chongZhiPingZheng: 'قسيمة إعادة الشحن',
  chongZhiShiJian: 'الوقت إعادة تعبئة الرصيد',
  chongZhiShuoMing: 'تعليمات إعادة الشحن:',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    'تعليمات الإيداع: الحد الأدنى لمبلغ الإيداع لـ USDT هو 120، والحد الأدنى لمبلغ الإيداع لـ BTC هو 0.015، والحد الأدنى لمبلغ الإيداع لـ ETH هو 0.2',
  close: 'إغلاق',
  'customerService.error': 'خدمة دعم العملاء غير متاحة مؤقتًا. يرجى المحاولة لاحقًا.',
  'customerService.close': 'إغلاق',
  'customerService.connected': 'متصل',
  'customerService.imageAlt': 'صورة دعم العملاء',
  'customerService.imagePreview': 'معاينة الصورة',
  'customerService.imageTooLarge': 'يجب ألا يتجاوز حجم الصورة 5 ميغابايت',
  'customerService.imageTypeUnsupported': 'يتم دعم صور PNG أو JPEG أو WebP فقط',
  'customerService.imageUnavailable': 'الصورة غير متاحة',
  'customerService.loadFailed': 'تعذر تحميل خدمة دعم العملاء عبر الإنترنت. يرجى المحاولة لاحقًا.',
  'customerService.loading': 'جارٍ التحميل…',
  'customerService.loginRequired': 'يرجى تسجيل الدخول للتواصل مع الدعم',
  'customerService.openImage': 'فتح الصورة',
  'customerService.placeholder': 'اكتب رسالة واضغط Enter للإرسال',
  'customerService.send': 'إرسال',
  'customerService.sendImage': 'إرسال صورة',
  'customerService.reconnecting': 'جارٍ إعادة الاتصال',
  'customerService.title': 'الدعم',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    'تتخذ معظم مواقع الويب خطوات لحماية المعلومات الشخصية للمستخدمين، مثل استخدام تقنية التشفير لحماية كلمات المرور.',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    'تسمح معظم مواقع الويب للمستخدمين بتغيير معلوماتهم الشخصية، مثل تغيير عنوان البريد الإلكتروني أو كلمة المرور الخاصة بهم. \nومع ذلك، قد لا يتم تغيير بعض المعلومات، مثل اسم المستخدم.',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    'لا توجد فائدة مطلوبة خلال {num} من الأيام بعد الحصول على القرض، وسيتم دفع الفائدة بعد {num} من الأيام.',
  daiShenHe: 'في انتظار المراجعة',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    'ومع ذلك، إذا كان موقع الويب أو التطبيق الذي تستخدمه به ثغرة أمنية، فقد يتم كشف معلوماتك الشخصية.',
  dangQiLiRun: 'الربح للفترة الحالية',
  dangQianLiXi: 'الفائدة الحالية',
  daoQiHuanXiHuanBen: 'سداد الفائدة ورأس المال عند استحقاقه',
  daoQiShiJian: 'تاريخ انتهاء الصلاحية',
  dengLuChengGong: 'تم تسجيل الدخول بنجاح',
  di: 'قليل',
  dianHuaHaoMa: 'رقم هاتف:',
  dieJiaLiShuai: 'تراكب سعر الفائدة:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: 'عالي',
  gouMai: 'يشتري',
  gouMaiChengGong: 'تم الشراء بنجاح',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    'تتصل حسابات العملات الدولية بخدمات الدعم عبر الإنترنت للمطابقة',
  home: {
    Application: 'طلب',
    AvailableOnThe: 'متوفر على',
    CreditCard: 'التشفير',
    CreditCardInfo:
      'باستخدام العملة المشفرة للودائع، يمكنك الحصول على طبقة إضافية من الأمان وتضمن معالجة سريعة للمعاملات.',
    CryptocurrenciesListed: 'العملات المشفرة المدرجة',
    GetStarted: 'يبدأ',
    NewFeaturesInOnline: 'ميزات جديدة على الإنترنت',
    NewFeaturesInOnlineInfo: 'تعرف على الميزات المثيرة لهذه المنصة الكاملة',
    RegisteredUsers: 'مستخدم مسجل',
    allChains: 'All Chains',
    announcementClose: 'إغلاق الإعلان',
    announcementLabel: 'إعلان',
    announcementView: 'عرض التفاصيل',
    announcementAmount: 'المبلغ المُقرض',
    announcementAnnualRate: 'العائد السنوي',
    announcementBelowMinimum: 'أقل من {amount} USDT',
    announcementCompoundInterest: 'فائدة مركبة',
    announcementCurrentConfig: 'الإعدادات الحالية',
    announcementEarningMode: 'طريقة احتساب الفائدة',
    announcementRateNotice:
      'تُحسب الأرباح وفق شرائح المنصة الحالية. تظهر المبالغ النهائية في صفحة الأصول وسجلات التسوية.',
    announcementRatesLoading: 'جارٍ تحميل شرائح العائد الحالية…',
    announcementSettlement: 'أوقات التسوية اليومية',
    announcementSimpleInterest: 'فائدة بسيطة',
    announcementYieldEyebrow: 'معلومات العائد',
    announcementYieldIntro:
      'تحصل مبالغ الإقراض الأعلى على عائد سنوي أعلى. يمكن للمبالغ الأقل من الشريحة الأولى المشاركة دون احتساب فائدة.',
    announcementYieldTitle: 'تفاصيل العائد الحالي',
    appLicationInfo:
      'الخدمات المصرفية عبر الهاتف المحمول التي تتخلى عن القواعد التقليدية لتزويدك بأدوات إدارة مالية دقيقة.',
    billion: 'ب',
    billionInfo: 'متوسط ​​حجم التداول على مدار 24 ساعة',
    button1Title: 'الحد الأدنى لرسوم المعاملات',
    button1Title1: 'تداول جميع أصولك في مكان واحد',
    button1Title2: 'الفوركس، العملات المشفرة، الأسهم، صناديق الاستثمار المتداولة، العقود الآجلة',
    button2Title: 'أسعار فائدة منخفضة وحدود أعلى',
    button2Title1: 'الاقتراض الاستثماري',
    button2Title2: 'لا توجد ضمانات مطلوبة، اقترض بسهولة واستمتع بفرصة زيادة الثروة!',
    button3Title: 'بسيطة ومستقرة',
    button3Title1: 'التداول الذكي',
    button3Title2: 'قم بإنشاء خطة الربح الخاصة بك بنقرة واحدة',
    button4Title: 'مساعدة الأطفال في جميع أنحاء العالم',
    button4Title1: 'مؤسسة NFT الخيرية',
    button4Title2: 'قم بشراء فن NFT لدعم اليونيسف',
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: 'قدّم السيولة لمجمع الإقراض لكسب الفائدة',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: 'قم بشراء وتداول والاحتفاظ بأكثر من 350 عملة مشفرة على أفضل منصة.',
    loading: 'Loading...',
    million: 'م',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: 'يمكن للمحفظة استبدال BTC بالدولار الأمريكي',
    noticeInfo1: 'تعمل مع حساب تجريبي',
    periodDays: '{count} day | {count} days',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
  },
  huanKuanZhong: 'جاري السداد',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    'مرحبًا بكم في استخدام منصة التداول المالي الحائزة على جوائز واستكشاف العالم المالي المستقبلي مع المستثمرين العالميين!',
  jiXiShiJian: 'وقت استحقاق الفائدة',
  jiXuTouZi: 'استمر في الاستثمار',
  jiangTuPianTuoFangDaoCiChuHuo: 'قم بسحب وإسقاط صورة هنا، أو',
  jieZhiShiJian: 'موعد التسليم',
  jiuMiMa: 'كلمة المرور القديمة',
  juJueYuanYin: 'سبب الرفض',
  kai: 'يفتح',
  lendingAssets: {
    authorizedBalance: 'الرصيد المصرح به',
    availableAmount: 'متاح للسحب',
    dailyOrders: 'أوامر التسوية اليومية',
    dailyProfit: 'الربح اليومي',
    joinPool: 'الانضمام إلى المجمع',
    loadMore: 'تحميل المزيد',
    needAuth: 'انضم إلى مجمع الإقراض لعرض الأرصدة والأرباح',
    needLogin: 'يرجى تسجيل الدخول لعرض أصولك',
    noOrders: 'لا توجد أوامر تسوية بعد',
    pageDesc: 'عرض الأرصدة المصرح بها وأرباح مجمع الإقراض وأوامر التسوية اليومية',
    poolEarnings: 'أرباح مجمع الإقراض',
    todayEarnings: 'اليوم',
    totalEarnings: 'إجمالي الأرباح',
    withdraw: 'سحب',
    withdrawRecords: 'سجل السحب',
    withdrawnAmount: 'تم سحبه',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      '<p><strong>إصدار المستند:</strong> V3.28 &nbsp;|&nbsp; <strong>تاريخ الإصدار:</strong> 2022 &nbsp;|&nbsp; <strong>نوع المستند:</strong> ورقة بيضاء للمنتج وملخص تقييم الأمان</p>\n\n<h2>1. الملخص التنفيذي</h2>\n<p>وحدة Lending Pool هذه هي خدمة إقراض وسيولة على السلسلة مبنية على بروتوكولات DeFi لسوق النقد. من خلال العقود الذكية مفتوحة المصدر ونماذج الفائدة البرمجية، يربط النظام أصول المستخدمين الرقمية بأسواق الإقراض على السلسلة، مما يتيح <strong>العائد على الودائع، والاقتراض المضمون، ومشاركة السيولة</strong>.</p>\n<p>لا تعتمد الوحدة على تدخل يدوي في توزيع الأموال اليومي. يتم تحديد الأسعار والسعة والاستخدام في الوقت الفعلي بواسطة الأسواق على السلسلة وتُعرض بشفافية عبر تجميع البيانات من مصادر متعددة.</p>\n\n<h2>2. خلفية الصناعة وموقع المنتج</h2>\n<p>يعتمد الإقراض التقليدي على مؤسسات مركزية. تستخدم بروتوكولات DeFi العقود الذكية لمطابقة العرض والطلب تلقائياً، مع ضمانات زائدة وآليات تصفية.</p>\n<p>موقع هذه الوحدة:</p>\n<ul>\n  <li><strong>بوابة سوق النقد على السلسلة:</strong> تجميع بيانات pools عبر سلاسل وبروتوكولات متعددة؛</li>\n  <li><strong>توزيع برمجي للعوائد:</strong> تسوية تلقائية وفق جدول ثابت بناءً على الأرصدة المصرح بها وAPY السوق؛</li>\n  <li><strong>شفاف وقابل للتحقق:</strong> TVL وAPY والاستخدام وLTV قابلة للتتبع إلى بيانات على السلسلة؛</li>\n  <li><strong>غير حاضنة:</strong> يبدأ التفويض والتفاعلات على السلسلة من محفظة المستخدم.</li>\n</ul>\n\n<h2>3. بنية النظام</h2>\n<h3>3.1 نظرة عامة</h3>\n<ul>\n  <li><strong>طبقة واجهة المستخدم:</strong> ربط المحفظة، التفويض، تصفح pools، استعلام الأرباح؛</li>\n  <li><strong>طبقة الخدمات:</strong> المصادقة، إدارة التفويض، أوامر العائد، محتوى متعدد اللغات؛</li>\n  <li><strong>طبقة تجميع البيانات:</strong> مزامنة مجدولة من مصادر DeFi العامة؛</li>\n  <li><strong>طبقة البروتوكول على السلسلة:</strong> عقود إقراض مدققة تنفذ منطق الإيداع والاقتراض.</li>\n</ul>\n\n<h3>3.2 المقاييس الأساسية</h3>\n<table>\n  <thead>\n    <tr><th>المقياس</th><th>الوصف</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>إجمالي أصول ال pool بالدولار</td></tr>\n    <tr><td>Supply APY</td><td>العائد السنوي للودائع</td></tr>\n    <tr><td>Borrow APY</td><td>التكلفة السنوية للمقترضين</td></tr>\n    <tr><td>معدل الاستخدام</td><td>نسبة الأموال المقترضة إلى المتاحة</td></tr>\n    <tr><td>Max LTV</td><td>أقصى نسبة قرض إلى قيمة قبل التصفية</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>حدود لكل أصل للتحكم في تركز المخاطر</td></tr>\n    <tr><td>السيولة المتاحة</td><td>سيولة قابلة للاقتراض فوراً</td></tr>\n  </tbody>\n</table>\n\n<h2>4. مسار المستخدم وآلية العائد</h2>\n<ol>\n  <li><strong>ربط المحفظة</strong> عبر Web3؛</li>\n  <li><strong>تفويض الأصول</strong> (USDT، USDC، إلخ) عبر Approve على السلسلة؛</li>\n  <li><strong>الانضمام إلى lending pool</strong> للدخول في قائمة حساب العائد؛</li>\n  <li><strong>تسوية العائد</strong> يومياً بناءً على الرصيد المصرح به وأسعار السوق؛</li>\n  <li><strong>عرض الأصول</strong> في «محفظتي».</li>\n</ol>\n<p><strong>APY التاريخي لا يضمن عوائد مستقبلية.</strong></p>\n\n<h3>4.3 الرسوم</h3>\n<h4>كيف تُفرض رسوم DeFi Earn؟</h4>\n<p>تتطلب المعاملات على السلسلة رسوم gas لإتمام التفاعل مع العقود الذكية، بما في ذلك الاشتراك واستلام العوائد. بالنسبة لبعض الأصول، قد يفرض lending pool DeFi ومديرو vault رسوم أداء كنسبة من أرباحك الفعلية؛ لا يتأثر رأس المال.</p>\n\n<h2>5. تصميم الأمان</h2>\n<ul>\n  <li>بروتوكولات أساسية بعقود مفتوحة المصدر ومدققة؛</li>\n  <li>بنية غير حاضنة؛ لا تخزين للمفاتيح الخاصة؛</li>\n  <li>أقل صلاحيات Token Approve؛ قابلة للإلغاء في أي وقت؛</li>\n  <li>مصادقة token، HTTPS، RBAC إدارية، وسجلات تدقيق.</li>\n</ul>\n\n<h2>6. ملخص تقييم الأمان</h2>\n<table>\n  <thead>\n    <tr><th>البند</th><th>النتيجة</th><th>ملاحظات</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>اعتماديات العقود الذكية</td><td><strong>ناجح</strong></td><td>بروتوكولات DeFi مدققة علناً</td></tr>\n    <tr><td>غير حاضنة وإدارة المفاتيح</td><td><strong>ناجح</strong></td><td>لا تخزين للمفاتيح الخاصة</td></tr>\n    <tr><td>API والمصادقة</td><td><strong>ناجح</strong></td><td>مصادقة token وHTTPS</td></tr>\n    <tr><td>مزامنة البيانات</td><td><strong>ناجح</strong></td><td>مزامنة مجدولة مع snapshots</td></tr>\n    <tr><td>منطق تسوية العائد</td><td><strong>ناجح</strong></td><td>قواعد واضحة؛ أوامر قابلة للتدقيق</td></tr>\n  </tbody>\n</table>\n\n<h2>7. الإفصاح عن المخاطر</h2>\n<ul>\n  <li><strong>مخاطر العقود الذكية:</strong> قد توجد ثغرات غير مكتشفة؛</li>\n  <li><strong>مخاطر السوق:</strong> APY قد يتقلب بشكل كبير؛</li>\n  <li><strong>مخاطر التصفية:</strong> انخفاض حاد في الضمان قد يؤدي إلى التصفية؛</li>\n  <li><strong>مخاطر فك ربط stablecoin:</strong> USDT/USDC قد تنحرف عن 1.00$؛</li>\n  <li><strong>مخاطر تنظيمية:</strong> تنظيم DeFi لا يزال يتطور عالمياً.</li>\n</ul>\n<p><strong>لا توفر هذه الوحدة نصيحة استثمارية ولا تضمن عوائد ثابتة.</strong></p>\n\n<h2>8. مسرد المصطلحات</h2>\n<ul>\n  <li><strong>APY:</strong> العائد السنوي؛</li>\n  <li><strong>TVL:</strong> إجمالي القيمة المقفلة؛</li>\n  <li><strong>LTV:</strong> نسبة القرض إلى القيمة؛</li>\n  <li><strong>Approve:</strong> تفويض token ERC-20؛</li>\n  <li><strong>التصفية (Liquidation):</strong> بيع تلقائي للضمان عند نقصه.</li>\n</ul>\n\n<p>— لأغراض إعلامية فقط. لا يُعد نصيحة قانونية أو مالية أو استثمارية. تحقق من البيانات على السلسلة عبر مستكشفات الكتل والواجهات الرسمية للبروتوكولات.</p>',
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: 'يرجى تسجيل الدخول قبل التحقق من الهوية',
    needVerifyHint: 'يرجى إكمال التحقق من الهوية قبل الانضمام إلى مجمع الإقراض',
    pageDesc: 'أكمل التحقق من الهوية للانضمام إلى مجمع الإقراض',
    pendingHint: 'التحقق من هويتك قيد المراجعة. يرجى الانتظار',
  },
  lendingMenu: {
    assets: 'الأصول',
    chooseDepositAsset: 'اختر أصلاً للإيداع',
    chooseDepositHint: 'أودع الأصول في مجمع الإقراض لكسب العائد وتمكين الاقتراض',
    copyUid: 'نسخ UID',
    customerService: 'Customer Service',
    depositAssetAction: 'إيداع {symbol}',
    earnings: 'طرق الربح',
    empty: 'لا يوجد محتوى',
    explore: 'استكشاف',
    footerDesc:
      'سوق نقدي على السلسلة من الجيل التالي مبني على عقود ذكية مفتوحة المصدر. قواعد برمجية تحل محل التحكم اليدوي، لتقديم خدمات إيداع وإقراض سيولة آمنة وشفافة لمستخدمي Web3 حول العالم.',
    getStarted: 'انضم الآن',
    home: 'الرئيسية',
    identityVerification: 'التحقق من الهوية',
    intro: 'نبذة',
    language: 'اللغة',
    noAssetPool: 'لم يتم العثور على مجمع إقراض لهذا الأصل',
    rulesSecurity: 'Rules & Security',
    security: 'الأمان',
    theme: 'المظهر',
    uid: 'UID',
    whitepaper: 'الورقة البيضاء',
    yieldLadder: 'سُلّم العائد',
  },
  lendingTheme: {
    auto: 'النظام',
    dark: 'داكن',
    light: 'فاتح',
    title: 'المظهر',
  },
  lendingYieldLadder: {
    balance: 'أصل القرض الواحد (USDT)',
    compoundInterest: 'فائدة مركبة',
    earningMode: 'وضع احتساب العائد: {mode}',
    empty: 'لم يتم إعداد مستويات العائد بعد',
    loading: 'جارٍ تحميل معدلات المستويات…',
    noteFixed: 'تسوية يومية بالمعدل الثابت لهذا المستوى',
    noteRange: 'تسوية يومية عند الحد الأعلى للنطاق',
    notes: 'ملاحظات',
    rate: 'نطاق العائد اليومي',
    settlementHours: 'أوقات التسوية المضبوطة: {hours}',
    simpleInterest: 'فائدة بسيطة',
  },
  liangCiMiMaBuYiZhi: 'كلمتا مرور غير متناسقتين',
  loan: {
    Browse: 'تصفح',
    address: 'عنوان:',
    birthdate: 'تاريخ الميلاد:',
    borrow: 'يُقرض',
    borrowNow: 'الاقتراض الآن',
    borrowPlaceholder: 'أريد أن أقترض...',
    browse: 'تصفح',
    checkIn: 'اكتمل التقديم',
    confirm: 'يتأكد',
    continue: 'يكمل',
    country: 'أمة:',
    dailyRate: 'سعر الفائدة اليومي',
    days: 'سماء',
    document: 'وثائق:',
    done: 'ينهي!',
    driverLicense: 'رخصة قيادة',
    dropHere: 'قم بسحب وإسقاط الصورة هنا',
    ensure: 'بالتأكيد',
    female: 'أنثى',
    firstName: 'اسم:',
    idCard: 'بطاقة التعريف',
    inHand: 'التقاط الصور',
    lastName: 'اسم العائلة:',
    launchCamera: 'تشغيل الكاميرا',
    loanAgreement: 'اتفاقية قرض',
    loanAmount: 'مبلغ القرض',
    loanDetail: 'تفاصيل القرض',
    loanTerm: 'فترة قرض',
    male: 'ذكر',
    notVerifyBtn: 'ابدأ عملية التحقق',
    notVerifyTip: 'تحقق من هويتك واحصل على المزيد من حدود القرض!',
    or: 'أو',
    passport: 'جواز سفر',
    pendingReview: 'قيد المراجعة',
    phone: 'رقم هاتف:',
    phonePlaceholder: 'أدخل رقم هاتفك...',
    reSign: 'إعادة التوقيع',
    resubmit: 'إعادة الإرسال',
    sex: 'انثى ذكر:',
    sign: 'لافتة',
    signTip: 'يرجى التأكيد والتوقيع',
    signed: 'وقعت',
    startVerfication: 'ابدأ عملية التحقق',
    submit: 'يُقدِّم',
    supports: 'الدعم: جبغ، جبيغ2000، ينغ',
    takePhoto: 'تصوير',
    term: 'مدة القرض (أيام)',
    tipIdCardBack: 'ضع الجزء الخلفي من بطاقة الهوية في الإطار',
    tipIdCardFront: 'ضع الجزء الأمامي من بطاقة الهوية في الإطار',
    tipNotPass:
      'عذرًا، لم ينجح طلب KYC الخاص بك في اجتياز عملية التحقق. \nيرجى إعادة إرسال مواد الطلب الصحيحة لإكمال التحقق من KYC. \nإذا كان لديك أي أسئلة أو كنت بحاجة إلى المساعدة، فلا تتردد في الاتصال بفريق خدمة العملاء لدينا.',
    tipTakePhoto: 'يرجى عقد الخاص بك',
    tipVerifiedSuccess:
      'تهانينا! \nتم التحقق من تطبيق KYC الخاص بك ويمكنك الآن الاستمتاع بمستوى أعلى من الخدمة.',
    tipWaitForResult:
      'نشكرك على تقديم معلومات شهادة KYC الخاصة بك. \nسيقوم فريقنا بمراجعة معلوماتك خلال 48 ساعة، يرجى التحلي بالصبر!',
    title: 'يُقرض',
    totalAmount: 'إجمالي مبلغ الفائدة',
    verifiedSuccessfully: 'تم التحقق بنجاح',
    verifiedUnsuccessfully: 'فشل التحقق',
    verifyBtn: 'تم التحقق بنجاح',
    verifyTip: 'احصل على أموال فورية لحماية استثمارك!',
  },
  login: {
    btnContinueFacebook: 'استمر في استخدام الفيسبوك',
    btnContinueGoogle: 'استمر في استخدام جوجل',
    btnLogin: 'تسجيل الدخول',
    btnLoginFacebook: 'تسجيل الدخول باستخدام الفيسبوك',
    btnLoginGoogle: 'الدخول مع جوجل',
    btnNext: 'الخطوة التالية',
    btnRecovery: 'يسترد',
    btnRecoveryPsd: 'استرجاع كلمة المرور',
    btnRegister: 'يسجل',
    btnRegisterFacebook: 'اشترك عبر حساب فايسبوك',
    btnRegisterGoogle: 'سجل باستخدام جوجل',
    btnSend: 'يرسل',
    btnSignup: 'سجل باستخدام البريد الإلكتروني',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'أدخل البريد الإلكتروني، مثل name@example.com',
    emailTips: 'هذا البريد الإلكتروني مسجل مسبقًا.',
    hasAccount: 'هل لديك حساب؟',
    hasNotAccount: 'لا تملك حسابا حتى الآن؟',
    inputCode: 'يرجى إدخال رمز التحقق',
    inputEmail: 'يرجى إدخال البريد الإلكتروني',
    inputPassword: 'يرجى إدخال كلمة المرور',
    inputPhone: 'يرجى إدخال البريد الإلكتروني',
    inputUsernameOrEmail: 'أدخل اسم المستخدم أو البريد',
    labelEmail: 'بريد:',
    labelEmailCode: 'رمز التحقق:',
    labelPsd: 'كلمة المرور:',
    labelPsdNew: 'كلمة المرور الجديدة:',
    labelPsdRepeat: 'تأكيد كلمة المرور:',
    labelUsername: 'اسم المستخدم:',
    labelUsernameOrEmail: 'اسم المستخدم أو البريد:',
    phone: 'بريد:',
    phoneTips: 'تم تسجيل عنوان البريد الإلكتروني هذا',
    starLogin: 'لنبدأ بتسجيل الدخول!',
    starRegist: 'لنبدأ بالتسجيل!',
    starReset: 'استرجاع كلمة المرور عبر البريد الإلكتروني!',
    tipRegisterContent:
      'أكمل تسجيلك وافتح الباب أمام عالم مثير من فرص الاستثمار، مما يمهد الطريق للنجاح والنمو المالي!',
    tipRegisterTitle: 'قم بالتسجيل وابدأ رحلتك الاستثمارية المزدهرة!',
    useEmailRegister: 'التسجيل باستخدام البريد الإلكتروني',
    usePhoneRegister: 'التسجيل باستخدام رقم الهاتف',
    username: 'اسم المستخدم',
    usernameOptional: 'اسم المستخدم (اختياري؛ إن تُرك فارغًا يُستخدم البريد)',
    usernameTips: 'اسم المستخدم هذا موجود بالفعل!',
    welcome: 'مرحبا بك في',
  },
  navBottom: {
    bottomCompany: 'شركة',
    bottomCompanyItem1: 'معلومات عنا',
    bottomCompanyItem2: 'الإشراف على الترخيص',
    bottomCompanyItem3: 'مشكلة شائعة',
    bottomCompanyItem4: 'الدعم عبر الإنترنت',
    bottomOther: 'إفادة',
    bottomOtherItem1: 'المعلومات القانونية',
    bottomOtherItem2: 'تنصل',
    bottomOtherItem3: 'تحذير من المخاطر',
    bottomOtherItem4: 'سياسة ملفات الارتباط',
    bottomOtherItem5: 'حول الإعلان',
    bottomPolicy: 'سياسة',
    bottomPolicyItem1: 'الأحكام والشروط',
    bottomPolicyItem2: 'سياسة الخصوصية',
    bottomProduct: 'منتج',
    bottomProductItem1: 'قائمة السوق',
    bottomProductItem2: 'الإقراض الاستثماري',
    bottomProductItem3: 'الرفاهية العامة NFT',
    bottomProductItem4: 'التداول الذكي',
  },
  navTab: {
    btnLogin: 'تسجيل الدخول',
    btnSignup: 'يسجل',
    language: 'لغة',
    languageTips: 'اختر اللغة والمنطقة',
    tabMenu1: 'الصفحة الأمامية',
    tabMenu2: 'سوق',
    tabMenu3: 'التداول الذكي',
    tabMenu4: 'يُقرض',
    tabMenu5: 'NFTs',
    tabMenu6: 'حساب',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: 'سعر إيقاف الخسارة الذي أدخلته غير معقول',
  ninShuRuDeZhiYingJiaGeBuHeLi: 'سعر جني الأرباح الذي أدخلته غير معقول',
  ntfs: {
    Address: 'عنوان',
    AllMoneyCharities: 'سيتم التبرع بجميع عائدات بيع NFTs إلى جمعيات اليونيسف الخيرية',
    BuyNFT: 'قم بشراء فن NFT وساعد الأطفال حول العالم!',
    BuyNow: 'اشتر الآن',
    Chain: 'سلسلة تابعة',
    Confirm: 'يتأكد',
    Creator: 'المنشئ',
    CumulativeDonation: 'التبرعات المتراكمة',
    CurrentBid: 'مناقصه قائمة',
    Markets: 'سوق',
    MyNFTs: 'بلدي NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'تفاصيل NFTs',
    PlaceABid: 'مُنَاقَصَة',
    RemainingTime: 'الوقت المتبقي',
    Successful: 'نجاح',
    ThanksDonation: 'شكرا لك على تبرعك',
    Thisaddress: 'سيتم إرسال العنصر إلى عنوان محفظتك',
    Verified: 'تم التحقق',
    andUNICEF: 'سيتم التبرع بالتبرعات لليونيسف',
    charity: 'خيرية',
  },
  null: 'خطأ غير معروف',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: 'يرجى التبديل إلى عملية الحساب الحقيقي',
  qingShangChuanPingZheng: 'الرجاء تحميل الشهادة',
  qingShuRuDiZhi: 'الرجاء إدخال العنوان',
  qingShuRuShouJiHao: 'يرجى إدخال البريد الإلكتروني الخاص بك',
  qingShuRuTouZiJinE: 'الرجاء إدخال مبلغ الاستثمار',
  qingShuRuYanZhengMa: 'الرجاء إدخال رمز التحقق',
  qingShuRuZhengQueDeJinE: 'الرجاء إدخال المبلغ الصحيح',
  qingShuRuZhengQueDeYouXiang: 'الرجاء إدخال البريد الإلكتروني الخاص بك صالح',
  qingShuRuZhiSunJiaGe: 'الرجاء إدخال سعر وقف الخسارة',
  qingShuRuZhiYingJiaGe: 'الرجاء إدخال سعر جني الأرباح',
  qingTianXieWanZhengXinXi: 'يرجى ملء المعلومات كاملة',
  qingZaiCiShuRuMiMa: 'الرجاء إدخال كلمة المرور مرة أخرى',
  queRenMiMa: 'تأكيد كلمة المرور',
  repaySuccess: 'تم السداد بنجاح',
  ri: 'يوم',
  riLiShuai: 'سعر الفائدة اليومي:',
  search: {
    SearchHere: 'يبحث',
  },
  shangChuanShiBaiQingZhongShi: 'فشل التحميل، يرجى المحاولة مرة أخرى',
  shenHeBuTongGuo: 'لم يتم اجتياز التدقيق',
  shou: 'يستلم',
  shouJiHao: 'بريد',
  shouXuFeiShiJiDaoZhangJinE: 'رسوم المناولة / المبلغ الفعلي المستلم',
  shouYiZhong: 'دخل',
  shouYiZhuangTai: 'حالة الدخل',
  shuRuNinDeDianHuaHaoMa: 'أدخل رقم هاتفك...',
  souSuo: 'يبحث...',
  tiJiaoChengGong: 'تم الإرسال بنجاح',
  tiJiaoChongZhiPingZheng: 'إرسال قسيمة إعادة الشحن',
  tiKuanFangShi: 'طريقة السحب',
  tiXian: 'ينسحب',
  tiXianDiZhi: 'عنوان السحب',
  tiXianShiJian: 'وقت الانسحاب',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    'يتطلب السحب رسوم معالجة تبلغ {rate}%، الأمر الذي يتطلب تأكيدًا من عقدة الشبكة قبل أن يتم إيداعها في الحساب. يرجى عدم تحويل العملة المشفرة إلى الغرباء.',
  toast: {
    UnreasonablePriceProfitLoss: 'إعدادات سعر أخذ الربح وإيقاف الخسارة غير معقولة',
    buyNumbers: 'الرجاء إدخال كمية الشراء',
    copyError: 'فشل النسخ!',
    copySuccess: 'تم النسخ بنجاح!',
    email: 'رجاءا أدخل بريدك الإلكتروني',
    inputAll: 'إدخال بيانات غير مكتمل',
    logOut: 'تسجيل الخروج',
    noData: 'لا مزيد من البيانات',
    notAddress: 'الرجاء إدخال عنوان المحفظة',
    notAmount: 'الرجاء إدخال المبلغ',
    notEmail: 'تنسيق البريد الإلكتروني غير صحيح',
    notImage: 'تنسيق الصورة غير صحيح',
    notLoanAmount: 'الرجاء إدخال مبلغ القرض',
    notSigned: 'غير موقعة',
    notSmartAmount: 'الرجاء إدخال المبلغ المالي',
    notSupportMedia: 'الحصول على وسائط المستخدم غير مدعوم',
    notVerify: 'يرجى إكمال عملية التحقق من KYC أولاً',
    notWithdrawAmount: 'الرجاء إدخال مبلغ السحب',
    nothingfound: 'لم يتم العثور على محتوى حتى الآن!',
    password: 'الرجاء إدخال كلمة المرور',
    passwordNotSame: 'إدخال كلمة المرور غير متناسق',
    passwordRepeat: 'يرجى التأكد من صحة كلمة المرور الخاصة بك',
    uploadImage: 'يرجى تحميل الصور المطلوبة',
    userName: 'الرجاء إدخال اسم المستخدم',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    'عادةً ما تكون المعلومات الأساسية مثل بريدك الإلكتروني واسم المستخدم وكلمة المرور وأحيانًا المعلومات الشخصية ومعلومات الاتصال مطلوبة.',
  touZiShiJian: 'وقت الاستثمار',
  touZiZhouQi: 'دورة الاستثمار',
  tuPianDaXiaoBuNengChaoGuo_2mb: 'لا يمكن أن يتجاوز حجم الصورة 2 ميغابايت!',
  tuPianDaXiaoBuNengChaoGuo_5m: 'لا يمكن أن يتجاوز حجم الصورة 50M!',
  uploadfailed: 'التحميل فشل',
  usdtZuiDiChongZhiJinewei_120: 'الحد الأدنى لمبلغ الإيداع لـ {name} هو {limit}',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    'إن القياس الكمي للتداول الآلي في الفوركس هو طريقة تستخدم برامج الكمبيوتر والخوارزميات لتنفيذ استراتيجيات التداول تلقائيًا. \nتستخدم هذه الطريقة البيانات التاريخية والمؤشرات الفنية والنماذج الإحصائية وغيرها من الأدوات التحليلية لتحديد إشارات التداول وتنفيذ هذه الإشارات تلقائيًا عند تنفيذ الصفقات. \nيمكن أن يساعد القياس الكمي للتداول الآلي في الفوركس المتداولين على التخلص من تأثير العواطف، وتقليل المعاملات الخاطئة، وتحسين كفاءة المعاملات واتساقها. \nومع ذلك، فإن القياس الكمي لتداول العملات الأجنبية ينطوي أيضًا على بعض المخاطر والقيود المحتملة. \nعلى سبيل المثال، قد لا تكون برامج التداول الآلي قادرة على التكيف مع تغيرات السوق، وتعتمد جودة وفعالية برامج التداول والخوارزميات إلى حد كبير على موثوقية وصحة البيانات التاريخية. \nبالإضافة إلى ذلك، قد ينطوي التداول الآلي أيضًا على مخاطر فنية، مثل فشل الكمبيوتر، وانقطاع الشبكة، وما إلى ذلك. لذلك، قبل استخدام القياس الكمي لتداول العملات الأجنبية الآلي، يحتاج المستثمرون إلى تقييم أهداف التداول الخاصة بهم بعناية، وتحمل المخاطر والقدرات التقنية، واختيار وسيط موثوق به. منصة التداول . \nمنصات التداول وبرامج التداول الآلي. \nوالأهم من ذلك، يجب على المستثمرين دائمًا توخي الحذر واتخاذ التدابير المناسبة لإدارة المخاطر لحماية استثماراتهم.',
  wallet: {
    connectWallet: 'توصيل المحفظة',
    justCanWallet: 'هذا الموقع يقبل فقط الوصول من خلال تطبيقات اللامركزية (Dapp)',
    pleaseConnectWallet: 'يرجى توصيل المحفظة',
  },
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    'انتهت مهلة الشبكة، يرجى الانتقال إلى قائمة الطلبات لعرض الطلب',
  weiKaiQiZhiNengJiaoYi: 'لم يتم تمكين التداول الذكي',
  weiRenZheng: 'غير معتمد',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: 'لماذا أحتاج للتسجيل للحصول على حساب؟',
  weiTongGuo: 'لم ينجح',
  woDeZhuCeXinXiHuiBeiBaoMiMa: 'هل سيتم الحفاظ على سرية معلومات التسجيل الخاصة بي؟',
  woKeYiGengGaiWoDeZhuCeXinXiMa: 'هل يمكنني تغيير معلومات التسجيل الخاصة بي؟',
  woKeYiZhuCeDuoGeZhangHuMa: 'هل يمكنني تسجيل حسابات متعددة؟',
  xiaCiShouYiShiJian: 'وقت الأرباح القادم',
  xiaDanChengGong: 'تم طلبه بنجاح',
  xinGongNengShangXian: 'الميزات الجديدة متاحة على الإنترنت!',
  xinMiMa: 'كلمة المرور الجديدة',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: 'لا يمكن للحسابات التجريبية استخدام هذه الميزة',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi: 'لا يمكن للحسابات التجريبية استخدام التداول الذكي',
  yanShiZhangHuYiJinYong: 'تم تعطيل الحساب التجريبي',
  yiDaoQi: 'تكون منتهية الصلاحية',
  yiFenRun: 'لقد تم تقسيم الربح',
  yiFenRunTianShu: 'عدد أيام تقاسم الأرباح',
  yiHuanKuan: 'سداد',
  yiJuJue: 'مرفوض',
  yiQieHuanWeiXuNiZhangHu: 'تم التحويل إلى الحساب الافتراضي',
  yiQieHuanWeiZhenShiZhangHu: 'تحولت إلى الحساب الحقيقي',
  yiRenZheng: 'تم التحقق',
  yiWanCheng: 'مكتمل',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    'قد تسمح بعض مواقع الويب للمستخدمين بتسجيل حسابات متعددة، لكن معظم مواقع الويب تسمح لكل مستخدم فقط بتسجيل حساب واحد. \nإذا حاولت تسجيل حسابات متعددة، فقد يتم حظر حسابك أو حذفه.',
  zhangFu: 'يزيد',
  zhenFu: 'السعة',
  zhuCeChengGong: 'نجاح التسجيل',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    'يتيح لك تسجيل الحساب استخدام ميزات الموقع أو التطبيق بشكل أكثر سهولة ويحمي معلوماتك الشخصية.',
  zhuCeZhangHuXuYaoShiMoXinXi: 'ما هي المعلومات المطلوبة لتسجيل الحساب؟',
  zongLiXi: 'مجموع الفوائد',
  zuiDiJia: 'أقل سعر',
}
